<template>
  <div class="container-card el-row">
    <el-row>
      <el-col class="mr20" :span="12">
        <el-card>
          <div class="flex-space-between">
            <div class="flex-center">
              <div class="wallet-label">
                <p>
                  Dollar<br />
                  Balance
                </p>
                <hr />
                <p>
                  VidCents<br />
                  Balance
                </p>
              </div>
              <div class="border-vertical"></div>
              <div class="wallet-amount">
                <div class="flex-start">
                  <span>$</span>
                  <p>{{ data.dollar }}</p>
                </div>
                <hr />
                <div class="flex-start">
                  <img id="vc" src="@/assets/images/vc.svg" alt="" />
                  <p>{{ data.vidCents }}</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-card class="data">
          <div class="data-title" slot="header">
            <img class="report-img" src="@/assets/images/tracks.svg" alt="" />
            <span>DEPOSIT</span>
          </div>
          <div class="flex-space-between">
            <!-- Credit card -->
            <div class="payment">
              <h4>CREDIT CARD</h4>
              <el-alert type="success" v-if="nonce">
                Successfully generated nonce.
              </el-alert>
              <el-alert type="danger" v-if="error">
                {{ error }}
              </el-alert>
              <el-form class="form" :model="form">
                <el-form-item label="Amount $" :label-width="formLabelWidth">
                  <el-input
                    v-model="amount"
                    placeholder="100$"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="Credit Card Number"
                  :label-width="formLabelWidth"
                >
                  <el-input autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Expire Date" :label-width="formLabelWidth">
                  <el-input
                    placeholder="DD/MM/YYYY"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item label="CVV" :label-width="formLabelWidth">
                  <el-input autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
              <el-button
                type="primary btn-main ml-auto"
                @click="payWithCreditCard"
                >Submit</el-button
              >
            </div>
            <!-- Paypal -->
            <div class="payment">
              <h4>Paypal</h4>
              <el-alert type="success" v-if="nonce">
                Successfully generated nonce.
              </el-alert>
              <el-alert type="danger" v-if="error">
                {{ error }}
              </el-alert>

              <el-form class="form" :model="form">
                <el-form-item label="Amount $" :label-width="formLabelWidth">
                  <el-input
                    v-model="amount"
                    placeholder="100$"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="Username / Email"
                  :label-width="formLabelWidth"
                >
                  <el-input autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
              <el-button
                type="primary btn-main ml-auto"
                @click="payWithCreditCard"
                >Submit</el-button
              >
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="10">
      <el-col :span="24">
        <el-card>
          <div slot="header">
            <span>Payment history</span>
          </div>
          <el-table :data="paymentHistory">
            <el-table-column label="Vidcents" prop="vidcents">
              <template slot-scope="props">
                <span>
                  {{ commaNum(props.row.vidcents) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Dollars" prop="dollar">
              <template slot-scope="props">
                <span> ${{ commaNum(props.row.dollar) }} </span>
              </template>
            </el-table-column>
            <el-table-column label="Payment date" prop="created_at">
              <template slot-scope="props">
                {{ props.row.created_at | date }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from '@/plugins/axios'
import braintree from 'braintree-web'
import paypal from 'paypal-checkout'
import { Message } from 'element-ui'

export default {
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('labelVidCents', ['data', 'paymentHistory'])
  },

  data() {
    return {
      hostedFieldInstance: false,
      nonce: '',
      error: '',
      amount: 50,
      history: [],
      payment: {
        amount: 0,
        nonce: null
      },
      form: {
        amount: ''
      },
      formLabelWidth: '200px'
    }
  },
  methods: {
    ...mapActions('labelVidCents', [
      'getBalance',
      'setpayment',
      'getPaymentHistory'
    ]),
    payWithCreditCard() {
      if (parseFloat(this.amount) < 50) {
        Message({
          type: 'error',
          message: 'Amount needs to be at least 50$!'
        })
      } else if (this.hostedFieldInstance) {
        this.error = ''
        this.nonce = ''
        this.hostedFieldInstance
          .tokenize()
          .then(payload => {
            this.nonce = payload.nonce
            this.payment.nonce = this.nonce
            this.payment.amount = this.amount
            this.setpayment(this.payment)
          })
          .catch(err => {
            console.error(err)
            this.error = err.message
          })
      }
    }
  },
  created() {
    // 134547225
    axios.label
      .get(`token/${this.user.braintree_customer_id}`)
      .then(r => {
        braintree.client
          .create({
            authorization: r.data
          })
          .then(clientInstance => {
            let options = {
              client: clientInstance,
              styles: {
                input: {
                  'font-size': '14px',
                  'font-family': 'Helvetica'
                }
              },
              fields: {
                number: {
                  selector: '#creditCardNumber',
                  placeholder: 'Enter Credit Card'
                },
                cvv: {
                  selector: '#cvv',
                  placeholder: 'Enter CVV'
                },
                expirationDate: {
                  selector: '#expireDate',
                  placeholder: '00 / 0000'
                }
              }
            }
            return Promise.all([
              braintree.hostedFields.create(options),
              braintree.paypalCheckout.create({ client: clientInstance })
            ])
          })
          .then(instances => {
            const hostedFieldInstance = instances[0]
            const paypalCheckoutInstance = instances[1]
            // Use hostedFieldInstance to send data to Braintree
            this.hostedFieldInstance = hostedFieldInstance
            // Setup PayPal Button
            return paypal.Button.render(
              {
                env: 'sandbox',
                style: {
                  label: 'pay',
                  size: 'responsive',
                  shape: 'pill',
                  color: 'white',
                  height: 40,
                  tagline: false
                },
                payment: () => {
                  if (parseFloat(this.amount) < 50) {
                    Message({
                      type: 'error',
                      message: 'Amount needs to be at least 50$!'
                    })
                    return false
                  } else {
                    return paypalCheckoutInstance.createPayment({
                      flow: 'checkout',
                      intent: 'sale',
                      amount: this.amount,
                      displayName: 'Braintree Testing',
                      currency: 'USD'
                    })
                  }
                },
                onAuthorize: data => {
                  return paypalCheckoutInstance
                    .tokenizePayment(data)
                    .then(payload => {
                      this.error = ''
                      this.nonce = payload.nonce
                      this.payment.nonce = this.nonce
                      this.payment.amount = this.amount
                      this.setpayment(this.payment)
                    })
                },
                onCancel: data => {
                  console.log('Payment Cancelled')
                },
                onError: () => {
                  this.error =
                    'An error occurred while processing the paypal payment.'
                }
              },
              '#paypalButton'
            )
          })
          .catch(() => {})
      })
      .catch(() => {})

    this.getBalance()
    this.getPaymentHistory()
  }
}
</script>

<style scoped>
#creditCardNumber,
#expireDate,
#cvv {
  border: 1px solid #dcdfe6;
  border-radius: 15px;
  color: #606266;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
}
</style>
